import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManagePukalService } from '../../../../services/manage-pukal.service'
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { WMSValidators } from '../../../../shared/validators';
import { Observable } from 'rxjs';
import {AccountOffice } from '../../../../models/pukal-reports.model';

@Component({
    selector: 'dialog-other-editaccount',
    templateUrl: 'dialog.editaccount.html',
    styleUrls: ['dialog.editaccount.css']
})
export class EditAccountPukalOtherGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    isSubmit: boolean = false;
    editaccform: FormGroup;
    errorMessage: string = '';
    agencyCodes = [];
    objects = [];
    activations = [];
    accNo: string = this.data.selectedAcc.Acc_No;
    Acc_Sts_Code: string = '';
    creationDate: any;
    activationDate: any;
    lastModifiedDate: any;
    createdUserId: any;
    userId: any;
    selectedaccoffCode: any;

    accOffices$: Observable<AccountOffice[]>;
    warrant_auth_code: string = 'OT';

    constructor(public dialogRef: MatDialogRef<EditAccountPukalOtherGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.accOffices$ = this.managePukalService.getAccountOffices(this.warrant_auth_code);

        this.editaccform = new FormGroup({
            agencyname: new FormControl({ value: '', disabled: true }),
            selectedaccoffCode: new FormControl({ value: '', disabled: false }, Validators.required),
            pukalnumber: new FormControl({ value: '', disabled: true }),
            accstatus: new FormControl({ value: '', disabled: true }),
            invdepartment: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            invaddress: new FormControl({ value: '', disabled: false }, [Validators.maxLength(100)]),
            invofficername: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            invphoneno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            invfaxno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            invemail: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)]),
            invnamebankacc: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            invbankaccno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            departmentname: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(50)]),
            departmentaddress: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(100)]),
            departmentofficername: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            departmentphonenumber: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            departmentfaxnumber: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            departmentemail: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            chargedeparment: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            chargeaddress: new FormControl({ value: '', disabled: false }, [Validators.maxLength(100)]),
            chargeofficer: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            chargephoneno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            chargefaxno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            chargeemail: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });

        let init_sub = this.managePukalService.initEditOTHPukalAccountDetails(this.data.selectedAcc.Airline_Agency_Code,
            this.data.selectedAcc.Acc_Off_Code,
            this.data.selectedAcc.Acc_No)
            .subscribe(
                (value) => {
                    if (value.status === 200) {
                        this.agencyCodes = value.body["Airline_Agency_Code"];
                        this.Acc_Sts_Code = value.body["Acc_Sts_Code"];

                        this.editaccform.setValue({
                            agencyname: this.data.selectedAcc.Agency_Name,
                            selectedaccoffCode: this.data.selectedAcc.Acc_Off_Code,
                            pukalnumber: value.body["Acc_No"],
                            accstatus: this.data.selectedAcc.Acc_Sts,
                            invdepartment: value.body["Inv_Department_Name"],
                            invaddress: value.body["Inv_Address"],
                            invofficername: value.body["Inv_Officer_Name"],
                            invphoneno: value.body["Inv_Phone_No"],
                            invfaxno: value.body["Inv_Fax_No"],
                            invemail: value.body["Inv_Email"],
                            invnamebankacc: value.body["Name_Bank_Acc"],
                            invbankaccno: value.body["Bank_Acc_No"],
                            departmentname: value.body["Department_Name"],
                            departmentaddress: value.body["Address"],
                            departmentofficername: value.body["Officer_Name"],
                            departmentphonenumber: value.body["Phone_No"],
                            departmentfaxnumber: value.body["Fax_No"],
                            departmentemail: value.body["Email"],
                            chargedeparment: value.body["Pyt_Department_Name"],
                            chargeaddress: value.body["Pyt_Address"],
                            chargeofficer: value.body["Pyt_Officer_Name"],
                            chargephoneno: value.body["Pyt_Phone_No"],
                            chargefaxno: value.body["Pyt_Fax_No"],
                            chargeemail: value.body["Pyt_Email"]
                        });

                        this.creationDate = value.body["Creation_Date"];
                        this.activationDate = value.body["Activation_Date"];
                        this.lastModifiedDate = value.body["Sys_Date"];
                        this.createdUserId = value.body["Created_User_Id"];
                        this.userId = value.body["User_Id"];
                    }
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the changes?");

        if (cfm) {
            this.isSubmit = true;

            let editPukalAccount = {
                Airline_Agency_Code: this.agencyCodes,
                Acc_Off_Code: this.editaccform.get('selectedaccoffCode')!.value,
                Acc_No: this.editaccform.get('pukalnumber')!.value,
                Acc_Sts_Code: this.Acc_Sts_Code,
                Inv_Department_Name: this.editaccform.get('invdepartment')!.value,
                Inv_Address: this.editaccform.get("invaddress")!.value,
                Inv_Officer_Name: this.editaccform.get("invofficername")!.value,
                Inv_Phone_No: this.editaccform.get("invphoneno")!.value,
                Inv_Fax_No: this.editaccform.get("invfaxno")!.value,
                Inv_Email: this.editaccform.get("invemail")!.value,
                Name_Bank_Acc: this.editaccform.get("invnamebankacc")!.value,
                Bank_Acc_No: this.editaccform.get("invbankaccno")!.value,
                Department_Name: this.editaccform.get("departmentname")!.value,
                Address: this.editaccform.get("departmentaddress")!.value,
                Officer_Name: this.editaccform.get("departmentofficername")!.value,
                Phone_No: this.editaccform.get("departmentphonenumber")!.value,
                Fax_No: this.editaccform.get("departmentfaxnumber")!.value,
                Email: this.editaccform.get("departmentemail")!.value,
                Pyt_Department_Name: this.editaccform.get("chargedeparment")!.value,
                Pyt_Address: this.editaccform.get("chargeaddress")!.value,
                Pyt_Officer_Name: this.editaccform.get("chargeofficer")!.value,
                Pyt_Phone_No: this.editaccform.get("chargephoneno")!.value,
                Pyt_Fax_No: this.editaccform.get("chargefaxno")!.value,
                Pyt_Email: this.editaccform.get("chargeemail")!.value
            }

            let save_sub = this.managePukalService.updateOTHPukalAccountDetails(editPukalAccount)
                .subscribe(
                    (value) => {
                        // console.log(value);
                        if (value.status === 204) {

                        } else if (value.status === 200) {
                            // let cfm = confirm("New Pukal Account added. Do you want to add another Pukal Account?");

                            // if (cfm) {
                            //     //if true clear all the input fields
                            // } else {
                            this.dialogRef.close('Edit successful');
                            // }
                        } else {

                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}